import { useEffect } from 'react';
import {
  Navigate,
  NavigateOptions,
  useNavigate,
  useParams,
} from 'react-router-dom';
import {
  selectSelectedTeamMemberId,
  selectTeamMember,
} from 'redux/slices/selectedMemberSlice';
import { useAppDispatch, useAppSelector } from 'redux/store-hooks';
import { MemberDetailsPage } from '../../../member-details/memberDetailsPage';
import { FeatureFlagRouteGuard } from '../FeatureFlagRouteGuard';
import { Routes, SyncHook } from '../route-types';

export const MEMBER_DETAILS_PREFIX_PATH = '/member-details';

const useSyncHook: SyncHook = () => {
  const { guideId: routeGuideId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const reduxGuideId = useAppSelector(selectSelectedTeamMemberId);

  useEffect(() => {
    // Make sure there is a guideId in the route
    // If no guide in the route and there is in the redux, update the route to include a guideId
    if (!routeGuideId && reduxGuideId) {
      navigate(`${MEMBER_DETAILS_PREFIX_PATH}/guide/${reduxGuideId}`, {
        replace: true,
      });
    }
    // Make sure the selected guide in redux matches the route guideId
    if (routeGuideId && routeGuideId !== reduxGuideId) {
      dispatch(selectTeamMember(routeGuideId));
    }
  }, [routeGuideId, reduxGuideId]);
};

const routes: Routes = [
  {
    path: '/member-details',
    element: (
      <FeatureFlagRouteGuard featureFlag="member-details-embed">
        <Navigate to="/member-details" />
      </FeatureFlagRouteGuard>
    ),
  },
  {
    path: '/member-details',
    element: (
      <FeatureFlagRouteGuard featureFlag="member-details-embed">
        <MemberDetailsPage />
      </FeatureFlagRouteGuard>
    ),
  },
  {
    path: '/member-details/guide/:guideId',
    element: (
      <FeatureFlagRouteGuard featureFlag="member-details-embed">
        <MemberDetailsPage />
      </FeatureFlagRouteGuard>
    ),
  },
];

const useNavigationHooks = () => {
  const navigate = useNavigate();

  return {
    toMemberDetails: (guideId?: string, options?: NavigateOptions) => {
      // const navigate = useNavigate();
      let url = MEMBER_DETAILS_PREFIX_PATH;
      if (guideId && guideId !== 'none') {
        url += `/guide/${guideId}`;
      }

      navigate(url, options);
    },
  };
};

export const memberDetailsRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
